module.exports = __webpack_public_path__ + "img/about-patent5.27328ee.png";